module.exports = __webpack_public_path__ + "img/10.24851e0d.png";